// extracted by mini-css-extract-plugin
export default {"container":"_1vKAD","content":"NxmlZ","sidePanel":"FAjuM","videoRecorder":"_2xMVV"};